import { postRwgConversionCollect } from 'src/infrastructure/api/rwg';
import { getCookie } from './cookie';

// https://developers.google.com/actions-center/verticals/appointments/redirect/integration-steps/conversion-tracking
// Cookie に rwg_token が含まれる場合に Conversion Event を送信する
export const collectRwgConversion = () => {
  const rwgToken = getCookie('rwg_token');
  if (rwgToken) {
    postRwgConversionCollect({ rwgToken });
  }
};

// rsv-rails の reservation.booked_from に対応する値を返す
export const bookedFrom = () => {
  const rwgToken = getCookie('rwg_token');
  if (rwgToken) {
    return 'reserve_with_google';
  }
  return null;
};
